export default defineNuxtPlugin((nuxtApp) => {
  const handlers = new Map();

  // Funktion zum Empfangen von Nachrichten
  const handleMessage = (event) => {
    // Optional: Überprüfe die Herkunft (event.origin) oder die Nachricht selbst
    // if (event.origin !== 'https://dein-host.com') {
    //   return;
    // }

    const { type, payload } = event.data;

    if (handlers.has(type)) {
      handlers.get(type)(payload);
    }
  };

  // Event-Listener beim Laden des Plugins registrieren
  window.addEventListener('message', handleMessage);

  // Objekt, das an Vue-Komponenten übergeben wird
  const messenger = {
    // Methode zum Registrieren eines Handlers für einen bestimmten Nachrichtentyp
    on: (type, handler) => {
      if (typeof handler === 'function') {
        handlers.set(type, handler);
      }
    },
    // Methode zum Senden einer Nachricht an das iframe
    post: (iframeID, type, payload) => {
      const iframe = document.getElementById(iframeID);

      if (!iframe) {
        console.error(`iFrame mit der ID '${iframeID}' nicht gefunden`);
        return;
      } 
      
      // Die Nachricht, die gesendet wird, sollte die gleiche Struktur haben,
      // die das iFrame-Plugin erwartet (also ein Objekt mit 'type' und 'payload').
      const message = {
        type: type,
        payload: payload
      };

      // Sende die Nachricht an das iFrame
      iframe.contentWindow.postMessage(message, '*'); 
        
    }
  };

  // Gib das Messenger-Objekt als Teil des Plugins zurück
  return {
    provide: {
      iframeMessenger: messenger
    }
  };
});